export default class QRCode {
    constructor(json) {
        this.qrCodeUrl = json['qrCodeUrl'];
        this.supportedApplications = json['supportedApplications'];
    }
}